export default __webpack_public_path__ + "static/media/bg_358960072.5ec8ee24.webp";